
<mat-toolbar color="primary">

    <span class="hide-on-med-and-up"><a href="home" class="yellow-text" style="vertical-align: middle" >mobidawg</a></span>

    <a href="" routerLink="home" routerLinkActive="active"><span class="brand-logo yellow-text hide-on-small-only" style="padding-left: 4px">mobidawg</span></a>

    <span class="spacer hide-on-small-only"></span>


</mat-toolbar>



<!-- <mat-toolbar color="primary"> -->

    <!-- <button class="hide-on-med-and-up" mat-icon-button [matMenuTriggerFor]="mdwgmenu" aria-label="icon button for the menu."> -->
        <!-- <mat-icon class="yellow-text">menu</mat-icon> -->
    <!-- </button> -->
    <!-- <span class="hide-on-med-and-up"><a href="home" class="yellow-text" style="vertical-align: middle" >mobidawg</a></span> -->

    <!-- <mat-menu #mdwgmenu="matMenu"> -->
        <!-- <button mat-menu-item color="primary" routerLink="login" routerLinkActive="active"><span class="mdi mdi-login">&emsp;Login</span></button> -->
        <!-- <button mat-menu-item color="primary" routerLink="admin" routerLinkActive="active"><span class="mdi mdi-account-box-outline">&emsp;Admin</span></button> -->
        <!-- <button mat-menu-item color="primary" routerLink="home" routerLinkActive="active"><span class="mdi mdi-cogs">&emsp;Services</span></button> -->
        <!-- <button mat-menu-item color="primary" routerLink="contact-us" routerLinkActive="active"><span class="mdi mdi-file-document-edit">&emsp;Contact</span></button> -->
    <!-- </mat-menu> -->

    <!-- <a href="" routerLink="home" routerLinkActive="active"><span class="brand-logo yellow-text hide-on-small-only" style="padding-left: 4px">mobidawg</span></a> -->

    <!-- <span class="spacer hide-on-small-only"></span> -->

    <!-- <ul class="hide-on-small-only "> -->
        <!-- <button mat-flat-button color="primary" routerLink="login" routerLinkActive="active">Login</button> -->
        <!-- <button mat-flat-button color="primary" routerLink="admin" routerLinkActive="active">Admin</button> -->
        <!-- <button mat-flat-button color="primary" routerLink="home" routerLinkActive="active">Services</button> -->
        <!-- <button mat-flat-button color="primary" routerLink="contact-us" routerLinkActive="active">Contact</button> -->
    <!-- </ul> -->

      
<!-- </mat-toolbar> -->

  <script>

    $( document ).ready(function(){
        console.debug("WTF - outside ... ")
    $(".button-collapse").sideNav(    
        console.debug("WTF - inside ... click ..."),
        {
            closeOnClick: true
        }
    );
    });

</script>
